import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  flex-direction: column;
  /* border: 1px solid #fff; */
  box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  border-radius: 1.2rem;

  > button {
    display: flex;
    flex-direction: column;
  }

  &:hover {
    box-shadow: 6px 12px 20px rgba(0, 0, 0, 0.1);
    transform: translateY(-3px);
  }

  @media (max-width: 520px) {
    height: 19rem;
  }
`;

export const ImageChallenge = styled.img`
  width: 18.44rem;
  height: 10.22rem;
  border-radius: 1.2rem 1.2rem 0 0;
  object-fit: cover;
  object-position: center;

  @media (max-width: 1024px) {
    width: 100%;
    height: 10.22rem;
  }
`;

export const ChallengeDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.8rem;
  gap: 0.4rem;

  > h1 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.2rem;
    color: #1e88e5;
  }

  @media (max-width: 520px) {
    gap: 0.8rem;
  }
`;

export const SeasonDetails = styled.div`
  > p {
    font-family: 'RedHatDisplay-Medium';
    font-size: 0.8rem;
    color: #000;
  }
`;

export const Footer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 0.6rem;

  > .primary-button {
    height: 1.8rem;
    padding: 0.8rem;
    font-family: 'RedHatDisplay-Bold';
    font-size: 0.8rem;
    border-radius: 0.6rem;
    box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);

    > svg {
      margin-right: 0.3rem;
    }
  }
`;

export const CountUsers = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 0.4rem;
  }

  font-family: 'RedHatDisplay-Medium';
  font-size: 0.8rem;
  color: #000;
`;
